import { render, staticRenderFns } from "./LoadingSlice.vue?vue&type=template&id=80b8032c"
import script from "./LoadingSlice.vue?vue&type=script&lang=js"
export * from "./LoadingSlice.vue?vue&type=script&lang=js"
import style0 from "./LoadingSlice.vue?vue&type=style&index=0&id=80b8032c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports